import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-loader flex-column"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_3 = { class: "text-muted fs-6 fw-bold mt-5" }
const _hoisted_4 = {
  key: 1,
  class: "page-loader flex-column"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex align-items-center mt-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1)
const _hoisted_8 = { class: "text-muted fs-6 fw-bold ms-5" }
const _hoisted_9 = {
  key: 2,
  class: "page-loader"
}
const _hoisted_10 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_11 = { class: "visually-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loaderType === 'spinner-message')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.I18nUtils.translate("sea.loader.loading")), 1)
      ]))
    : (_ctx.loaderType === 'spinner-logo')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Logo",
            class: "h-15px",
            src: _ctx.logo
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.I18nUtils.translate("sea.loader.loading")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.I18nUtils.translate("sea.loader.loading")), 1)
          ])
        ]))
}